__turbopack_context__.v({
  "text": "Text-module__YqOPia__text",
  "textCenter": "Text-module__YqOPia__textCenter",
  "textEllipsis": "Text-module__YqOPia__textEllipsis",
  "textFlexYCentered": "Text-module__YqOPia__textFlexYCentered",
  "textHoverable": "Text-module__YqOPia__textHoverable",
  "textItalic": "Text-module__YqOPia__textItalic",
  "textLeft": "Text-module__YqOPia__textLeft",
  "textLineClamp": "Text-module__YqOPia__textLineClamp",
  "textLineClamp1": "Text-module__YqOPia__textLineClamp1",
  "textLineClamp2": "Text-module__YqOPia__textLineClamp2",
  "textLineClamp3": "Text-module__YqOPia__textLineClamp3",
  "textNoWrap": "Text-module__YqOPia__textNoWrap",
  "textRight": "Text-module__YqOPia__textRight",
  "textTakeAvailableSpace": "Text-module__YqOPia__textTakeAvailableSpace",
  "textUnderline": "Text-module__YqOPia__textUnderline",
  "textWordBreakAll": "Text-module__YqOPia__textWordBreakAll",
});
